import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Layout, Card } from 'tea-component';
import _ from 'lodash-es';
import { history, useIntl } from 'umi';
import { useSafeState, useSetState } from 'ahooks';
// import StreamingGamesFilter from './components/Sizer';
import StreamingGamesEcahrts from './components/GamesEcahrts';
import StreamingGamesTableList from './components/GamesTableList';
import { TOP_COMPANIES_NUM } from '../../TopCharts/_config/topChartsConst';
// import { isDiffClearArr } from '../Kol/utils';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import {
  // cleanObject,
  useSearchParamsState,
} from '../../GlobalView/MarketSize/hooks/useQuery';
import '@/pages/intelligence/assets/scss/Streaming/kolDetails.scss';
import moment from 'moment';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { commonMobileDefaultFilterValue, handleStreamingGameFilterParamsToApi } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import { getStreamingGamesFiltersData } from '@/pages/intelligence/services/filter';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { STREAMING_GAMETYPE_OPTIONS } from '@intelligence/pages/TopCharts/components/CommonFilter/constant';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

type ITypeItems = 'hoursWatched' | 'peackCCV' | 'avgCCV' | 'airtime';
interface ITabsType {
  subTab: ITypeItems;
  data?: any[];
  loading?: boolean;
}
const { Body, Content } = Layout;

export default function StreamingGame(props: any) {
  const pageLogInfo = dbiPageLogMes.streamingGames;

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.streamingGame?.type,
  });

  useEffect(() => {
    buriedPointPage(pageLogInfo);
  }, []);

  const defaultFilterValue = {
    ...commonMobileDefaultFilterValue,
    [filterKeyMap.GENRETOR]: {
      source: 'iegg',
      mainGenres: [],
      subGenres: [],
    },
    [filterKeyMap.KOL_PLATFORM]: { value: ['twitch', 'ytg', 'facebook',] },
    [filterKeyMap.STREAMING_GAME_TYPE]: { value: STREAMING_GAMETYPE_OPTIONS?.[0].value }
  };

  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: [
      // filterKeyMap.MY_FILTER,
      filterKeyMap.RANGE_TIME,
      filterKeyMap.GENRETOR,
      filterKeyMap.STREAMING_GAME_TYPE,
      // filterKeyMap.PLATFORM,
      filterKeyMap.KOL_PLATFORM,
      filterKeyMap.ALL_COMPANYS,
      filterKeyMap.RELEASE_TIME,
    ],
    companyFilterParams: {
      platform: ['twitch', 'ytg', 'facebook'],
      period: 'day',
      check_metric: 'hoursWatched',
      search_name: '',
      page: 1,
      page_size: 500,
      source_metric: {},
    },
    getCompaniesFetch: getStreamingGamesFiltersData,
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'date',
        value: [moment().subtract(30, 'd'), moment().subtract(1, 'd')],
      },
    },
    specialParams: {
      regionOptions: [], //国家筛选器options,
      defalutMarket: ['global'], //没取到交集用的默认值
      disableNoChina: false,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: false,
    },
    showConfirmButton: true,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleStreamingGameFilterParamsToApi,
  };

  return (
    <StreamingGamesComp
      // pageLogInfo={pageLogInfo}
      filterCfg={filterCfg}
      // filterLoading={false}
      rangeTimeComponentDefault={latestTimeTypeHasData}
    />
  );
}

const StreamingGamesComp = (props: any) => {
  const { filterCfg, rangeTimeComponentDefault } = props;
  const { formatMessage } = useIntl();
  // common默认参数,当common默认参数变化的时候，整个页面将会render
  const [paramsDefault, setParamsDefault] = useSetState<{
    [key in string]: unknown;
  }>({
    platform: ['twitch', 'ytg', 'facebook'],
    start_date: '',
    end_date: '',
    // period: 'day',
    period: 'daily',
    check_metric: 'hoursWatched',
    order: 'desc',
    order_metric: 'hoursWatched',
    // sub_genre: [],
    // genre: [],
    genre_source: 'iegg',
    iegg_genre_req: [],
    company: [],
    release_start_date: '',
    release_end_date: '',
    page: 1,
    page_size: 100,
    gameCode: [],
    game_type: STREAMING_GAMETYPE_OPTIONS?.[0].value,
  });
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const [filterValue, setFilterVale] = useState(DEFAULT_FORM_VALUE)

  const [timeConfig, setTimeConfig] = useState({
    start_date: '',
    end_date: '',
  })

  const timeDefaultObj = rangeTimeComponentDefault?.date || ['', ''];
  const startDateDefault = Array.isArray(timeDefaultObj) && timeDefaultObj?.length > 1 ? moment(timeDefaultObj[0]).format('YYYY-MM-DD') : '';
  const endDateDefault = Array.isArray(timeDefaultObj) && timeDefaultObj?.length > 1 ? moment(timeDefaultObj[1]).format('YYYY-MM-DD') : '';

  const [tableLoading, setTableLoading] = useState(true);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const startDateCur = useMemo(() => {
    return startDate == '' ? startDateDefault : startDate;
  }, [startDateDefault, startDate, rangeTimeComponentDefault]);
  const endDateCur = useMemo(() => {
    return endDate == '' ? endDateDefault : endDate;
  }, [endDateDefault, endDate, rangeTimeComponentDefault]);

  const [subTab] = useSearchParamsState('subTab', 'hoursWatched');
  // 表格纽带
  const intableRef = useRef<Partial<ITabsType>>();

  // 这个参数不像TopCharts模块，可以直接往图表数据进行push,不进行接口拉取,需要根据传入的AppIds进行report,
  const [userIds, setUserIds] = useSafeState({
    addNumber: TOP_COMPANIES_NUM,
    userList: [],
  });
  // useMount(() => {
  //   buriedPointPage(dbiPageLogMes.streamingGames);
  // });
  // 筛选器submit
  const handleConfirm = (value: { [x: string]: any }) => {
    // const {
    //   date_type: period,
    //   iegg_genre_req: iegg_genre_reqs,
    //   isDiffIeggLength,
    //   ...restProps
    // } = value;
    intableRef.current?.ecahrtsIsRefresh();
    setParamsDefault({
      // period,
      check_metric: subTab,
      order_metric: subTab,
      ...value,
      // genre_source: value.genre_source ? value.genre_source : '',
      // iegg_genre_req: isDiffClearArr(iegg_genre_reqs, isDiffIeggLength),
      // genre: value.genre_source ? [] : value.genre,
      // sub_genre: value.genre_source ? [] : value.sub_genre,
      // ..._.omit(cleanObject(restProps), ['isDiffIeggLength']),
    });
    setTimeConfig({
      start_date: value.start_date,
      end_date: value.end_date
    });
    setStartDate(value.start_date);
    setEndDate(value.end_date);
  };
  // 筛选器reset
  const handleReset = () => {
    // console.log('reset filter  but The page data is not updated');
  };

  return (
    <Layout className="dbi-kol-details">
      <Body>
        <Content>
          <Content.Header
            onBackButtonClick={() => {
              history.goBack();
            }}
            title={formatMessage({ id: 'dbi_games' })}
          />
          <Content.Body full>
            <MarqueeBanner />
            <Card>
              <Card.Body>
                <Filter
                  isOperate={false}
                  timeFilterValues={{
                    type: paramsDefault?.period,
                    value: [timeConfig?.start_date, timeConfig?.end_date],
                  }}
                  filterConfirm={handleConfirm}
                  filterReset={handleReset}
                  filterValue={filterValue}
                  setFilterVale={setFilterVale}
                  filterCfg={filterCfg}
                  defaultValue={DEFAULT_FORM_VALUE}
                  rangeTimeComponentDefault={rangeTimeComponentDefault}
                />
              </Card.Body>
            </Card>
            <StreamingGamesEcahrts
              startDateCur={startDateCur}
              endDateCur={endDateCur}
              {...{
                paramsDefault,
                timeConfig,
                userIds,
                data: intableRef.current?.data,
                loading: tableLoading,
              }}
            />
            <StreamingGamesTableList
              intableRef={intableRef}
              {...{
                paramsDefault,
                setParamsDefault,
                setTableLoading,
                setTimeConfig,
                timeConfig,
                setUserIds,
                userIds,
                subTab,
              }}
            />
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};
